import type { Quote, QuoteItem, QuoteStatus } from '@/types'

/** Item category used for a free-text note instead of a product */
export const NOTE_CATEGORY = 'note'

export const NOTE_STATUSES: QuoteStatus[] = ['note_a_chiffrer', 'note_chiffree', 'note_abandonnee']

export function isNoteItem(item: Pick<QuoteItem, 'category'>): boolean {
  return item.category === NOTE_CATEGORY
}

/** A dossier is in note mode as soon as it holds a note (notes and products are exclusive) */
export function isNoteQuote(quote: Pick<Quote, 'items'>): boolean {
  return quote.items.some(isNoteItem)
}
